module.exports = __webpack_public_path__ + "static/media/DrukWide-Bold.39bf14b5.otf";